var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.135,
    height: 165,
    viewBox: "0 0 91.135 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1445.865 -74.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(1456.047 109.998)",
    fill: "#5efc8d",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67,
    height: 63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M288.528,75.63h-7.962a8.733,8.733,0,0,0-8.483-6.751H226.9a8.733,8.733,0,0,0-8.483,6.751h-7.964A6.134,6.134,0,0,0,204.4,81.69V192.653a6.134,6.134,0,0,0,6.059,6.059H288.7a6.134,6.134,0,0,0,6.059-6.059V81.69a6.282,6.282,0,0,0-6.232-6.059Zm.866,117.022a.818.818,0,0,1-.866.866H210.283a.818.818,0,0,1-.866-.866V81.688a.818.818,0,0,1,.866-.866h8.309a8.831,8.831,0,0,0,8.136,5.713H271.91a8.657,8.657,0,0,0,8.136-5.713h8.309a.818.818,0,0,1,.866.866V192.651Z",
    transform: "translate(1241.469 6.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M236.88,138.32v98.672h70.109V138.32Zm64.743,34.622-45.874,25.273a4.6,4.6,0,0,1-2.077.519,4.512,4.512,0,0,1-3.808-2.251l-9.694-16.964a4.3,4.3,0,1,1,7.443-4.328l7.443,13.33,42.239-23.2a4.326,4.326,0,0,1,5.885,1.732,4.007,4.007,0,0,1-1.558,5.885Z",
    transform: "translate(1219.026 -41.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "to_do",
    "data-name": "to do",
    transform: "translate(1446 229.998)",
    fill: "#fff",
    fontSize: 29,
    fontFamily: "Poppins-Black, Poppins",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TO DO")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.ab12dfb1cba621a56c21e17b4b50593c.svg";
export { ForwardRef as ReactComponent };